import React, { useState, useEffect, useRef } from "react";

import { useSelector } from "react-redux";

import { CommonAxios } from "../components/CommonAxios";
import Qna from "../components/notice/Qna";

const QnaPage = () => {
  return (
    <>
      <Qna />
    </>
  );
};

export default QnaPage;
